$(document).ready(function(){

  $('.yelp-reviews .wrapper.slide').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000
  });
  $('.bottom_content .img_slider_container').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: false,
    prevArrow:'<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchleft.svg?v=1612163653"></button>',
    nextArrow:'<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchright.svg?v=1612163653"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  });
  $('.bottom_content .band_sizes_container').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: false,
    prevArrow:'<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchleft.svg?v=1612163653"></button>',
    nextArrow:'<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchright.svg?v=1612163653"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }

    ]
  });
  console.log('READY');
  $('.bottom_content .watch_materials_container').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:'<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchleft.svg?v=1612163653"></button>',
    nextArrow:'<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchright.svg?v=1612163653"></button>',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }

    ]
  });
  $('.bottom_content .watch_accesories_container').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: false,
    prevArrow:'<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchleft.svg?v=1612163653"></button>',
    nextArrow:'<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1007/4862/files/totalwatchright.svg?v=1612163653"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }

    ]
  });
  // Help modal search bands
  if($('#open-help-modal').length > 0){
    $('#open-help-modal').magnificPopup({
      items: {
        src: `
<div class="white-popup">
<div class="help-modal text-center">
<p>
If your search results came up empty, let us help
you locate the proper strap for your watch.
</p>
<p>Please call us at</p>
<h4><strong><a href="tel:8778059988">(877) 805-9988</a></strong></h4>
<p>
or send us an <a href="mailto:info@totalwatchrepair.com">email</a> 
with your case or model number and we will get back to you within 24 hours.
</p>
</div>
</div>
`,
        type: 'inline'
      }
    });
  }

  // Search results 0 items
  $(document).on('click', '.model-search-links-box .search-bar--submit', function(e) {
    e.preventDefault();
    var $form = $(e.currentTarget).closest('form.model-search');
    var $searchInput = $form.find('input[name="q"]');
    var searchQuery = $searchInput.val();

    $form.find('.no-results').hide();

    var searchUrl = `/search?view=json&q=${searchQuery}`;
    $.ajax({
      url: searchUrl,
      type: 'GET',
      cache: false
    })
    .done(function(response) {
      var script = document.createElement("script");
      script.text = response;
      //console.log(response);
      document.head.appendChild(script).parentNode.removeChild(script);

      if (search_results_json.length == 0) {
        $form.find('.no-results').slideDown(500);
      }
      else {
        $form.submit();
      }
    });      

  });

  $('body').on('click','.boost-pfs-filter-tree-content .boost-pfs-filter-option-title',function(){
    $(this).parent().toggleClass('is_opend');
  });
  $(".alpha_filter span").on("click", function() {
    $('.alpha_filter span').removeClass('activetab');
  	$(this).addClass('activetab');
    
    var value = $(this).attr('data-alpha');
    $('.list_inner').removeClass('active');
    $('.list_inner.class_'+value).addClass('active');  
    if($('.list_inner.active').length > 0 ){
      $('.nobrand').removeClass('active');
    }else{
      $('.nobrand').addClass('active');
    }

  });
  $('.all_brand').on('click',function(){
    $('.alpha_filter span').removeClass('activetab');
    $('.list_inner').addClass('active');
    $('.nobrand').removeClass('active');
    $('html, body').animate({
      scrollTop: $(".alpha_filter").offset().top
    }, 2000);
  });
  
});

